export function extractFieldDecoratorProps({ error, required, readonly, label, labelTooltip, labelTooltipPlacement, labelFor, caption, hint, disabled, showHintIcon, size, validationState, className, }) {
    return {
        error,
        required,
        readonly,
        label,
        labelTooltip,
        labelTooltipPlacement,
        labelFor,
        caption,
        hint,
        disabled,
        showHintIcon,
        size,
        validationState,
        className,
    };
}
